"use client"

import { usePathname } from "next/navigation"
import { DesktopNavButton } from "./desktop-nav-button"
import { cn } from "@/lib/utils"

export function DesktopNavElement({
    className,
    ...props
}: React.ComponentProps<typeof DesktopNavButton>) {
    const pathname = usePathname()
    return (
        <DesktopNavButton
            className={cn(className, pathname === props.href && "opacity-100")}
            {...props}
        />
    )
}
